import { IApplicationState } from '../../types/redux';

export const selectDescriptionMarkup = (state: IApplicationState): string => {
  return state.projectData.project.descriptionMarkup;
};
